export enum EventType {
  Plain,
  Detailed,
}

export enum EventKind {
  OpenHistory = 'screen_history',

  CreateBudget = 'action_budget_create',
  RedistributeSaved = 'action_transfer_to_daily',
  TransferSavedToNextDay = 'action_transfer_to_tomorrow',

  AddSpend = 'action_spend_submit',
  AddIncome = 'action_income_submit',
  AddRefill = 'action_refill_submit',
  CancelSpend = 'action_spend_rollback',
  DeleteSpend = 'action_spend_delete',

  UserSpentEverything = 'event_budget_wasted',
  UserSavedMoney = 'event_budget_closed_with_balance',
}

export enum AppScreen {
  Main = 'main_screen',
}
